import Modal from '../ui/Modal';
import QRModal from '../ui/QRModal';
import ScalettaView from './ScalettaView';
import EventModal from '../modals/EventModal';
import { useState, useEffect, useRef, useCallback } from 'react';
import { supabase, getTracksForEvent, addEventOrganizer, removeEventOrganizer, addTrack as dbAddTrack, removeTrack as dbRemoveTrack, joinTrack as dbJoinTrack, leaveTrack as dbLeaveTrack, updateTrack as dbUpdateTrack, updateTrackPosition, addTrackToScaletta, removeTrackFromScaletta, getEventEquipment, getEventMusicianEquipment, getEventRequests, getMyEventRequest, approveEventRequest, rejectEventRequest, requestJoinEvent, updateEventLock, updateEventInvitesLock, updateEventProposalsOpen, setEventCardVisible, getEventParticipants, joinEventAsParticipant, leaveEventAsParticipant, getEventIdeas, addEventIdea, updateEventWhatsappLink, inviteToEvent } from '../lib/supabase';
import { isTrackReady, splitRoles, toDisplayLong, firstName, activeMusicians, normalizeInstrument, isEventOrganizer } from '../helpers';
import { INSTRUMENTS } from '../constants';
import { INSTRUMENT_ORDER } from '../helpers';
import SetlistItem from './SetlistItem';
import EquipmentSection from './EquipmentSection';
import ChatSection from './ChatSection';
import IdeasSection from './IdeasSection';
import TrackModal from '../modals/TrackModal';
import MusicianPopup from '../ui/MusicianPopup';
import VenuePopup from '../ui/VenuePopup';
import PosterViewer from '../ui/PosterViewer';
import AddToCalendar, { PILLOLA } from '../ui/AddToCalendar';
import { SchedaHome } from '../ui/MettiSullaHome';
function SetlistView({ event, currentUser, musicians, venues, venueEquipment, defaultVenueBg, onRefresh: refreshParent, onEditEvent, onDeleteEvent, onOpenLive }) {
  const [tracks,setTracks]=useState([]);
  const [stableOrder,setStableOrder]=useState([]); // ordine stabile, aggiornato solo su primo load
  const isFirstLoad=useRef(true);
  const [equipment,setEquipment]=useState([]);
  const [musicianEquipment,setMusicianEquipment]=useState([]);
  const [participants,setParticipants]=useState([]);
  const [requests,setRequests]=useState([]);
  const [myRequest,setMyRequest]=useState(null);
  const [loading,setLoading]=useState(true);
  const [showAdd,setShowAdd]=useState(false);
  const [showEditEvent,setShowEditEvent]=useState(false);
  const [editTrack,setEditTrack]=useState(null);
  const [confirmRemove,setConfirmRemove]=useState(null);
  const [showFreeJoin,setShowFreeJoin]=useState(null);
  // "Partecipo" e' un tocco solo: niente piu' domanda su cosa porti, che non
  // finiva nemmeno nella card Strumenti e attrezzatura. L'attrezzatura si
  // segna da li', con "Cosa porti".
  const [entrando,setEntrando]=useState(false);
  const [freeNote,setFreeNote]=useState("");
  const [freeRole,setFreeRole]=useState("");
  const [orderingLocked,setOrderingLocked]=useState(event.ordering_locked||false);
  const [orderingMode]=useState(event.ordering_mode||"auto");
  const [invitesLocked,setInvitesLocked]=useState(event.invites_locked||false);
  const [proposalsOpen,setProposalsOpen]=useState(!event.players_managed);
  // Card che chi organizza puo' spegnere per la serata. L'attrezzatura parte
  // accesa (manca solo se si spegne apposta), le idee partono spente: le
  // accende chi organizza, di solito quando la scaletta comincia a riempirsi.
  const [mostraAttrezzatura,setMostraAttrezzatura]=useState(event.show_equipment!==false);
  const [mostraIdee,setMostraIdee]=useState(event.show_ideas===true);
  // Anche la card Live parte spenta: si accende per la serata.
  const [mostraLive,setMostraLive]=useState(event.show_live===true);
  useEffect(()=>{setMostraLive(event.show_live===true);},[event.show_live]);
  useEffect(()=>{setMostraAttrezzatura(event.show_equipment!==false);},[event.show_equipment]);
  useEffect(()=>{setMostraIdee(event.show_ideas===true);},[event.show_ideas]);
  const [trackFilter,setTrackFilter]=useState("tutti"); // tutti | miei
  const [sortDir,setSortDir]=useState("asc"); // asc = meno coperti prima
  const [showScaletta,setShowScaletta]=useState(false);
  const [showQR,setShowQR]=useState(false);
  const [unreadChat,setUnreadChat]=useState(0);

  // Ordinamento per numero di musicisti iscritti
  const autoSort=(trackList,dir="asc")=>{
    return [...trackList].sort((a,b)=>{
      const ca=(a.track_players||[]).length;
      const cb=(b.track_players||[]).length;
      return dir==="asc"?ca-cb:cb-ca;
    });
  };
  const [popupMusician,setPopupMusician]=useState(null);
  const [popupVenue,setPopupVenue]=useState(null);
  const [showInvite,setShowInvite]=useState(false);
  const [copied,setCopied]=useState(false);
  const [showAddMusician,setShowAddMusician]=useState(false);
  const [musicianSearch,setMusicianSearch]=useState("");
  const [addingMusician,setAddingMusician]=useState(null);

  const isAdmin=currentUser.is_admin;
  // Organizza chi ha creato la serata e chi e' stato nominato co-organizzatore:
  // per la serata hanno gli stessi poteri. Solo chi l'ha creata (o l'admin)
  // nomina e toglie i co-organizzatori.
  const isManager=isEventOrganizer(event,currentUser.id);
  const isPrimaryManager=event.manager_id===currentUser.id;
  const canManage=isAdmin||isManager;
  const canChooseOrganizers=isAdmin||isPrimaryManager;
  const coOrgIds=(event.event_organizers||[]).map(o=>o.musician_id);
  const isOrgOfEvent=(id)=>event.manager_id===id||coOrgIds.includes(id);
  const [orgBusy,setOrgBusy]=useState(null);
  const [orgError,setOrgError]=useState("");
  const toggleCoOrganizer=async(musicianId)=>{
    setOrgBusy(musicianId); setOrgError("");
    try{
      if(coOrgIds.includes(musicianId)) await removeEventOrganizer(event.id,musicianId);
      else await addEventOrganizer(event.id,musicianId);
      await load(); refreshParent&&refreshParent();
    }catch(e){
      console.error(e);
      setOrgError("Non sono riuscito a cambiare gli organizzatori. Riprova tra poco.");
    }finally{ setOrgBusy(null); }
  };
  // Nomina dei co-organizzatori: sta nella scheda del musicista, non nell'elenco
  // dei partecipanti, e la vede solo chi ha creato la serata (o l'admin).
  // Un co-organizzatore che apre la propria scheda puo' solo lasciare.
  const renderAzioniOrganizzatore=(m)=>{
    const partecipa=participants.some(p=>p.musician_id===m.id);
    if(!partecipa||event.manager_id===m.id||m.account_type==="venue"||m.deleted_at)return null;
    const isCoOrg=coOrgIds.includes(m.id);
    const ioMiTolgo=isCoOrg&&m.id===currentUser.id&&!canChooseOrganizers;
    if(!canChooseOrganizers&&!ioMiTolgo)return null;
    const occupato=orgBusy===m.id;
    return(
      <div style={{marginBottom:16,paddingTop:4}}>
        <div style={{fontSize:16,fontWeight:700,color:"var(--muted)",letterSpacing:"1px",marginBottom:6}}>ORGANIZZAZIONE</div>
        <div style={{fontSize:16,color:"var(--muted)",lineHeight:1.4,marginBottom:10}}>
          {isCoOrg
            ?(ioMiTolgo?"Co-organizzi questa serata.":"Co-organizza questa serata con te, con i tuoi stessi poteri.")
            :"Se lo nomini co-organizzatore, gestisce la serata insieme a te: brani, scaletta, avvisi, richieste e pagina live."}
        </div>
        <button disabled={occupato} onClick={()=>toggleCoOrganizer(m.id)}
          style={{width:"100%",minHeight:48,borderRadius:999,cursor:"pointer",fontSize:17,fontWeight:700,fontFamily:"inherit",
            display:"flex",alignItems:"center",justifyContent:"center",
            border:isCoOrg?"1px solid rgba(255,255,255,0.18)":"1px solid rgba(237,77,29,0.45)",
            background:"none",color:isCoOrg?"var(--muted)":"var(--brand)"}}>
          {occupato?<span className="spinner"/>
            :isCoOrg?(ioMiTolgo?"Lascia l'organizzazione":"Togli dagli organizzatori")
            :"Nomina co-organizzatore"}
        </button>
        {orgError&&<div style={{fontSize:16,color:"#e08080",marginTop:8}}>{orgError}</div>}
      </div>
    );
  };
  const isMusicianUser=currentUser.accountType==="musician";
  const [showChatOverlay,setShowChatOverlay]=useState(false);
  const [whatsappGroupLink,setWhatsappGroupLink]=useState(event.whatsapp_group_link||null);
  const [attrezzaturaExpanded,setAttrezzaturaExpanded]=useState(false);
  const [braniExpanded,setBraniExpanded]=useState(false);
  const [chiVieneExpanded,setChiVieneExpanded]=useState(false);
  const [showPoster,setShowPoster]=useState(false);
  const [ideas,setIdeas]=useState([]);
  const [ideasExpanded,setIdeasExpanded]=useState(false);
  const [showAddIdea,setShowAddIdea]=useState(false);
  const [newIdeaText,setNewIdeaText]=useState("");
  const [addIdeaLoading,setAddIdeaLoading]=useState(false);
  const [avvisiCount,setAvvisiCount]=useState(0);
  const [showEditParticipation,setShowEditParticipation]=useState(false);
  const [confirmLeaveEvent,setConfirmLeaveEvent]=useState(false);

  const myParticipation=participants.find(p=>p.musician_id===currentUser.id);
  const isParticipating=!!myParticipation;

  const hasAccess=event.visibility==="open"||canManage||myRequest?.status==="approved"||isParticipating;
  const isPending=event.visibility==="request"&&myRequest?.status==="pending";

  const load=useCallback(async(silent=false)=>{
    if(!silent) setLoading(true);
    try{
      const [t,eq,meq,parts,ideasData]=await Promise.all([
        getTracksForEvent(event.id),
        getEventEquipment(event.id),
        getEventMusicianEquipment(event.id),
        getEventParticipants(event.id),
        getEventIdeas(event.id),
      ]);
      setTracks(t);setEquipment(eq);setMusicianEquipment(meq);setParticipants(parts);setIdeas(ideasData);
      // Basta il numero degli avvisi: l'ultimo avviso non si mostrava da nessuna
      // parte, e chiederlo era una richiesta in piu' a ogni aggiornamento.
      const {count:totAvvisi}=await supabase.from('event_messages').select('*',{count:'exact',head:true}).eq('event_id',event.id).eq('post_type','avviso');
      setAvvisiCount(totAvvisi||0);
      const lastSeen=localStorage.getItem(`jamup_bacheca_seen_${event.id}_${currentUser.id}`)||'1970-01-01T00:00:00Z';
      const {count:unread}=await supabase.from('event_messages').select('*',{count:'exact',head:true}).eq('event_id',event.id).eq('post_type','avviso').neq('musician_id',currentUser.id).gt('created_at',lastSeen);
      setUnreadChat(unread||0);
      // Aggiorna l'ordine stabile solo al primo load (montaggio), non su refresh
      if(isFirstLoad.current){
        setStableOrder(prev=>{
        const prevSet=new Set(prev);
        const newSet=new Set(t.map(tr=>tr.id));
        const idsChanged=prev.length===0||t.some(tr=>!prevSet.has(tr.id))||prev.some(id=>!newSet.has(id));
        if(idsChanged) return autoSort([...t].sort((a,b)=>(a.position??999)-(b.position??999)),"asc").map(tr=>tr.id);
        return prev; // player join/leave: non riordinare
      });
        isFirstLoad.current=false;
      }
      if(event.visibility==="request"&&isMusicianUser){
        const [reqs,myReq]=await Promise.all([getEventRequests(event.id),getMyEventRequest(event.id,currentUser.id)]);
        setRequests(reqs);setMyRequest(myReq);
      }
    }finally{setLoading(false);}
  },[event.id,currentUser.id,event.visibility,isMusicianUser]);

  useEffect(()=>{load();},[load]);

  // Raggruppa le notifiche ravvicinate in un solo ricaricamento.
  const reloadTimer=useRef(null);
  const scheduleReload=useCallback(()=>{
    if(reloadTimer.current)return;
    reloadTimer.current=setTimeout(()=>{reloadTimer.current=null;load(true);},500);
  },[load]);

  useEffect(()=>{
    // Prima ci si iscriveva a qualunque modifica di qualunque tabella: un like
    // su un'altra serata faceva ricaricare sette query anche qui. Ora si
    // ascoltano solo le tabelle che riguardano questo evento.
    const ch=supabase.channel(`event-${event.id}`);
    ['tracks','event_participants','event_equipment','event_musician_equipment','event_ideas','event_messages','event_requests']
      .forEach(table=>ch.on('postgres_changes',
        {event:'*',schema:'public',table,filter:`event_id=eq.${event.id}`},scheduleReload));
    ch.on('postgres_changes',
      {event:'UPDATE',schema:'public',table:'events',filter:`id=eq.${event.id}`},scheduleReload);
    // Queste due tabelle non hanno la colonna event_id e non si possono
    // filtrare: le ascoltiamo intere, ma sono solo loro e non tutto il database.
    ['track_players','idea_likes']
      .forEach(table=>ch.on('postgres_changes',{event:'*',schema:'public',table},scheduleReload));
    ch.subscribe();
    return()=>{
      if(reloadTimer.current){clearTimeout(reloadTimer.current);reloadTimer.current=null;}
      supabase.removeChannel(ch);
    };
  },[event.id,scheduleReload]);

  const manualSorted=[...tracks].sort((a,b)=>(a.position??999)-(b.position??999));
  // In modalità auto usa stableOrder per evitare salti visivi durante optimistic updates
  const autoSorted=stableOrder.length>0
    ? stableOrder.map(id=>tracks.find(t=>t.id===id)).filter(Boolean)
    : autoSort([...tracks].sort((a,b)=>(a.position??999)-(b.position??999)));
  const sorted=orderingMode==="manual"?manualSorted:autoSorted;

  const handleSortDir=(dir)=>{
    setSortDir(dir);
    setStableOrder(autoSort([...tracks].sort((a,b)=>(a.position??999)-(b.position??999)),dir).map(t=>t.id));
  };
  const normalTracks=(sorted||[]).filter(t=>t.type!=="free");

  // ── Brani ancora disponibili ────────────────────────────────────────────────
  // Per ogni strumento, quanti brani non hanno ancora nessuno su quel ruolo.
  // E' un conto di occasioni, non una percentuale: il totale non si mostra
  // apposta. Con quaranta proposte e venticinque brani suonati, "6 su 40"
  // suonerebbe come un allarme che non c'e'.
  const copreRuolo=(t,strumento)=>
    (t.track_players||[]).some(p=>splitRoles(p.role).some(r=>normalizeInstrument(r)===strumento));

  const disponibili=INSTRUMENT_ORDER.filter(i=>i!=='Altro')
    .map(strumento=>({strumento,count:normalTracks.filter(t=>!copreRuolo(t,strumento)).length}))
    .filter(d=>d.count>0);
  const filtroLibero=trackFilter.startsWith("libero:")?trackFilter.slice(7):null;
  const filteredNormal=
    trackFilter==="miei"
      // "Tuoi" = i brani in cui suoni, come il conteggio "N tuoi" sotto il
      // titolo. Prima contavano anche quelli proposti: per chi organizza e
      // carica i brani, "Tuoi" mostrava tutto e sembrava non filtrare.
      ? normalTracks.filter(t=>(t.track_players||[]).some(p=>p.musician_id===currentUser.id))
      : filtroLibero
        ? normalTracks.filter(t=>!copreRuolo(t,filtroLibero))
        : normalTracks;
  const readyTracks=filteredNormal.filter(t=>isTrackReady(t));
  const draftTracks=filteredNormal.filter(t=>!isTrackReady(t));

  // Costruisce ruolo default dal profilo utente
  const buildDefaultRole = () => {
    const parts = [];
    if(currentUser.default_sings) parts.push('Voce');
    if(currentUser.default_instrument) parts.push(currentUser.default_instrument);
    if(parts.length===0 && (currentUser.instruments||[]).length>0) parts.push(currentUser.instruments[0]);
    if(parts.length===0 && currentUser.sings) parts.push('Voce');
    return parts.join(', ');
  };



  const exportCSV = () => {
    const getNames = (players, keywords) => players
      .filter(p=>keywords.some(k=>p.role.toLowerCase().includes(k)))
      .map(p=>{ const m=musicians.find(mu=>mu.id===p.musician_id); return m?m.name.split(' ')[0]:''; })
      .join(' / ');
    const getOther = (players) => players
      .filter(p=>!['voce','tasti','piano','organ','chitar','guitar','batter','drum','basso','bass'].some(k=>p.role.toLowerCase().includes(k)))
      .map(p=>{ const m=musicians.find(mu=>mu.id===p.musician_id); return m?`${m.name.split(' ')[0]} (${p.role.replace('(alt)','').trim()})`:''; })
      .join(' / ');
    const header = ['Nr','Brano','Autore','Tonalità','Voce','Piano/Keys','Chitarra','Batteria','Basso','Altro'];
    const rows = normalTracks.map((t,i)=>{
      const pl = t.track_players||[];
      return [
        i+1,
        `"${(t.title||'').replace(/"/g,'""')}"`,
        `"${(t.artist||'').replace(/"/g,'""')}"`,
        `"${(t.key||'').replace(/"/g,'""')}"`,
        `"${getNames(pl,['voce'])}"`,
        `"${getNames(pl,['tasti','piano','organ','keyboard'])}"`,
        `"${getNames(pl,['chitar','guitar'])}"`,
        `"${getNames(pl,['batter','drum','percuss'])}"`,
        `"${getNames(pl,['basso','bass'])}"`,
        `"${getOther(pl)}"`,
      ].join(',');
    });
    const csv = [header.join(','), ...rows].join('\n');
    const blob = new Blob([csv], {type:'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `scaletta-${event.title.replace(/[^a-zA-Z0-9]/g,'-')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleAddTrack=async({title,artist,role,tonality,key,bpm,titles})=>{
    if(!isParticipating)await joinEventAsParticipant(event.id,currentUser.id,[]);
    const effectiveRole = role || buildDefaultRole();
    if(titles && titles.length>0){
      for(const t of titles){
        const track=await dbAddTrack({event_id:event.id,title:t,artist:"",key:null,bpm:null,proposed_by:currentUser.id,position:tracks.length,status:"auto"});
        if(effectiveRole) await dbJoinTrack(track.id,currentUser.id,effectiveRole,'originale');
      }
    } else {
      const track=await dbAddTrack({event_id:event.id,title,artist:artist||"",key:key||null,bpm:bpm||null,proposed_by:currentUser.id,position:tracks.length,status:"auto"});
      if(effectiveRole) await dbJoinTrack(track.id,currentUser.id,effectiveRole,tonality||'originale');
    }
    await load();setShowAdd(false);
  };
  const handleJoin=async(trackId,role,tonality,isAlt)=>{
    if(!isParticipating)await joinEventAsParticipant(event.id,currentUser.id,[]);
    // Optimistic update: aggiunge subito il player localmente
    const effectiveRole=isAlt?`${role} (alt)`:role;
    setTracks(prev=>prev.map(t=>t.id!==trackId?t:{
      ...t,
      track_players:[...(t.track_players||[]).filter(p=>p.musician_id!==currentUser.id),
        {track_id:trackId,musician_id:currentUser.id,role:effectiveRole,tonality}]
    }));
    await dbJoinTrack(trackId,currentUser.id,effectiveRole,tonality);
    await load(true);
  };
  const handleLeave=async(id)=>{
    // Optimistic update: rimuove subito il player localmente
    setTracks(prev=>prev.map(t=>t.id!==id?t:{
      ...t,
      track_players:(t.track_players||[]).filter(p=>p.musician_id!==currentUser.id)
    }));
    await dbLeaveTrack(id,currentUser.id);
    await load(true);
  };
  const handleRemove=async(id)=>{setConfirmRemove(id);};
  const handleRemoveConfirmed=async(id)=>{await dbRemoveTrack(id);setConfirmRemove(null);await load();};

  const handleToggleLock=async()=>{const v=!orderingLocked;setOrderingLocked(v);await updateEventLock(event.id,v);};
  const handleToggleInvitesLock=async()=>{const v=!invitesLocked;setInvitesLocked(v);await updateEventInvitesLock(event.id,v);};
  const partecipa=async()=>{
    if(entrando)return;
    setEntrando(true);
    try{ await joinEventAsParticipant(event.id,currentUser.id,[]); await load(); refreshParent&&refreshParent(); }
    catch(e){ console.error(e); alert("Non sono riuscito a segnarti. Riprova tra poco."); }
    finally{ setEntrando(false); }
  };
  const cambiaVisibilitaCard=async(card,visibile)=>{
    const imposta=card==='ideas'?setMostraIdee:card==='live'?setMostraLive:setMostraAttrezzatura;
    imposta(visibile);
    if(!visibile){ if(card==='ideas')setIdeasExpanded(false); else if(card==='equipment')setAttrezzaturaExpanded(false); }
    try{ await setEventCardVisible(event.id,card,visibile); refreshParent?.(); }
    catch(e){ console.error(e); imposta(!visibile); alert("Non sono riuscito a salvare. Riprova tra poco."); }
  };

  const pendingRequests=requests.filter(r=>r.status==="pending");
  const venue=venues.find(v=>v.id===event.venue_id);

  // Passo 2 del percorso d'invito: il link di Jammo a chi ha gia' detto si'.
  // Quando c'e' la locandina, data, ora e luogo li
  // dice lei (e l'anteprima del link la mostra): il testo spiega solo come
  // si partecipa. Senza locandina restano, sennò l'invito non direbbe ne'
  // quando ne' dove. Lo usano "Copia link", "WhatsApp" e il Condividi della
  // locandina.
  const inviteText=()=>{
    // Con la locandina il titolo e' gia' nell'immagine e nel titolo
    // dell'anteprima: il messaggio comincia dal testo. Senza, servono
    // titolo, data e luogo.
    const lines=[];
    if(!event.image_url){
      lines.push(`*${event.title}*`);
      lines.push(toDisplayLong(event.date)+(event.time_start?` · ${event.time_start}`+(event.time_end?` → ${event.time_end}`:""):""));
      const locationLine=venue?venue.name:(event.location_name||event.location||"");
      if(locationLine)lines.push(locationLine);
      lines.push("");
    }
    lines.push("Scegliamo insieme alcuni brani da suonare, e lo facciamo con l'app Jammo. Puoi proporre pezzi o scegliere quali suonare o cantare.");
    lines.push("");
    lines.push("Clicca il link e registrati!");
    lines.push("");
    lines.push(`https://jammo.live/e/${event.id}`);
    return lines.join("\n");
  };

  const handleCopy=()=>{
    navigator.clipboard.writeText(inviteText());
    setCopied(true);
    setTimeout(()=>setCopied(false),2500);
  };

  const handleWhatsApp=()=>{
    window.open(`https://wa.me/?text=${encodeURIComponent(inviteText())}`,"_blank");
  };

  const hasAnyVoice=normalTracks.some(t=>(t.track_players||[]).some(p=>p.role.toLowerCase().includes('voce')));

  // Preview strumenti: conta musicisti unici per ruolo
  const instrMap={};
  normalTracks.forEach(t=>{
    (t.track_players||[]).forEach(p=>{
      splitRoles(p.role).forEach(r=>{
        const k=normalizeInstrument(r);
        if(k){if(!instrMap[k])instrMap[k]=new Set();instrMap[k].add(p.musician_id);}
      });
    });
  });

  // Strumenti necessari mancanti
  const MUST_HAVE=[
    {label:'Chitarra', instrKeys:['Chitarra'], equipKeys:['chitar','guitar']},
    {label:'Basso',    instrKeys:['Basso'],    equipKeys:['basso','bass']},
    {label:'Batteria', instrKeys:['Batteria'], equipKeys:['batter','drum','percuss']},
    {label:'Piano/Keys', instrKeys:['Piano/Keys'], equipKeys:['tasti','piano','organ','keys','keyboard']},
  ];
  const venueEq=venueEquipment[event.venue_id]||[];
  const missingSlots=MUST_HAVE.filter(({instrKeys,equipKeys})=>{
    if(instrKeys.some(k=>(instrMap[k]||new Set()).size>0)) return false;
    if(venueEq.some(e=>equipKeys.some(k=>(e.item||'').toLowerCase().includes(k)))) return false;
    if(musicianEquipment.some(e=>equipKeys.some(k=>(e.item||'').toLowerCase().includes(k)))) return false;
    return true;
  });

  const cardStyle={marginBottom:12,background:"var(--surface)",border:"1px solid var(--border)",borderRadius:16,overflow:"hidden"};
  const openCard={...cardStyle,border:"1px solid rgba(237,77,29,0.45)"};
  const cardRowStyle={display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px 18px",cursor:"pointer",userSelect:"none",minHeight:52};
  const sectionTitleStyle={fontSize:19,fontWeight:800,color:"var(--text)"};
  const cardBodyStyle={padding:"0 18px 18px",borderTop:"1px solid var(--border)"};

  // Per chi organizza, una card spenta resta come riga sottile: si riaccende
  // da li', senza cercarla nelle impostazioni. I musicisti non la vedono.
  const renderCardSpenta=(titolo,card)=>(
    <div style={{...cardStyle,background:"transparent",border:"1px dashed var(--border)",display:"flex",alignItems:"center",gap:12,padding:"10px 18px",minHeight:52}}>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:18,fontWeight:700,color:"var(--muted)"}}>{titolo}</div>
        <div style={{fontSize:16,color:"var(--muted)",marginTop:2}}>Nascosta ai musicisti</div>
      </div>
      <button onClick={()=>cambiaVisibilitaCard(card,true)}
        style={{flexShrink:0,minHeight:44,padding:"8px 16px",borderRadius:999,cursor:"pointer",fontFamily:"inherit",
          fontSize:16,fontWeight:700,background:"rgba(237,77,29,0.08)",color:"var(--brand)",border:"1px solid rgba(237,77,29,0.3)"}}>
        Mostra
      </button>
    </div>
  );
  const renderNascondiCard=(card)=>(
    <div style={{textAlign:"center",marginTop:14}}>
      <button onClick={()=>cambiaVisibilitaCard(card,false)}
        style={{minHeight:44,padding:"8px 12px",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",
          fontSize:16,fontWeight:600,color:"var(--muted)",textDecoration:"underline"}}>
        Nascondi ai musicisti
      </button>
    </div>
  );
  const Chevron=({open})=>(
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2.5"
      strokeLinecap="round" strokeLinejoin="round"
      style={{flexShrink:0,transition:'transform .2s',transform:open?'rotate(180deg)':'rotate(0deg)'}}>
      <polyline points="6 9 12 15 18 9"/>
    </svg>
  );

  return (
    <div className="fade-up">
      {/* Header evento — sfondo venue (senza blur) o locandina sfocata come fallback */}
      {(()=>{const bg=venue?.background_image_url||defaultVenueBg; return(
      <div style={{position:'relative',marginBottom:20,background:"var(--surface)",borderRadius:16,overflow:'hidden',border:"1px solid var(--border)"}}>
        {bg
          ?<><img src={bg} alt="" style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',display:'block'}}/><div style={{position:'absolute',inset:0,background:'rgba(18,16,14,0.62)'}}/></>
          :event.image_url
            ?<img src={event.image_url} alt="" style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',filter:'blur(14px)',transform:'scale(1.1)',display:'block'}}/>
            :null
        }
        {/* La locandina come francobollo: lo sfondo resta l'atmosfera, la
            locandina si riconosce e si apre intera toccandola. */}
        {event.image_url&&(
          <button onClick={()=>setShowPoster(true)} aria-label="Apri la locandina"
            style={{position:'absolute',top:16,right:16,zIndex:1,width:72,height:108,padding:0,
              borderRadius:8,overflow:'hidden',cursor:'pointer',background:'#000',
              border:'1px solid rgba(255,255,255,0.25)',boxShadow:'0 4px 16px rgba(0,0,0,0.5)'}}>
            <img src={event.image_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover',display:'block'}}/>
          </button>
        )}
        <div style={{position:'relative',padding:'16px 18px 12px',paddingRight:event.image_url?104:18,minHeight:event.image_url?140:undefined,boxSizing:'border-box'}}>
          <div style={{fontSize:28,fontWeight:900,color:"var(--text)",lineHeight:1.1,marginBottom:8}}>
            {event.title}
          </div>
          <div style={{fontSize:17,color:"var(--muted)",marginBottom:6}}>
            {toDisplayLong(event.date)}{event.time_start?` · ${event.time_start}${event.time_end?` – ${event.time_end}`:""}`:""}</div>
          {(venue||event.location_name||event.location)&&(
            <div style={{marginBottom:4,fontSize:17,color:"var(--muted)",fontWeight:600}}>
              <span style={{cursor:venue?"pointer":undefined}} onClick={venue?()=>setPopupVenue(venue):undefined}>
                {/* Niente indirizzo: per arrivarci c'e' "Mappa". */}
                {[venue?.name||event.location_name,event.city||venue?.city].filter(Boolean).join(" · ")}
              </span>
            </div>
          )}
          {(()=>{
            const orgs=[event.manager_id,...coOrgIds]
              .map(id=>musicians.find(m=>m.id===id)).filter(Boolean);
            return orgs.length?<div style={{fontSize:16,color:"var(--muted)",marginTop:4}}>
              {orgs.length===1?"Organizzatore: ":"Organizzano: "}
              {orgs.map((m,i)=>(
                <span key={m.id}>
                  {i>0&&(i===orgs.length-1?" e ":", ")}
                  <span style={{color:"var(--text)",cursor:"pointer",fontWeight:600,textDecoration:"underline",textDecorationColor:"rgba(255,255,255,0.2)"}}
                    onClick={()=>setPopupMusician(m)}>{firstName(m.name)}</span>
                </span>
              ))}
            </div>:null;
          })()}
          {/* Le due azioni pratiche, affiancate e uguali: segnarla in agenda e
              arrivarci. Il calendario solo a chi partecipa o organizza. */}
          {(()=>{
            const haMappa=!!(venue?.address||event.location||event.city||venue?.city);
            const haCalendario=isParticipating||canManage;
            if(!haMappa&&!haCalendario)return null;
            // Stessa larghezza esatta: ognuna meta' riga meno meta' dello spazio
            // fra le due. Se ce n'e' una sola resta larga uguale, non si allarga.
            const meta={flex:"0 0 calc(50% - 5px)"};
            return <div style={{display:"flex",gap:10,marginTop:12}}>
              {haCalendario&&<AddToCalendar event={event} venue={venue} variante="pillola" style={{...meta,gap:3}} etichetta={<>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
                Calendario</>}/>}
              {haMappa&&<button style={{...PILLOLA,...meta}}
                onClick={()=>{const addr=venue?.address||event.location||"";const city=event.city||venue?.city||"";if(addr||city)window.open(`https://maps.google.com/?q=${encodeURIComponent([addr,city].filter(Boolean).join(', '))}`);}}>
                Mappa
              </button>}
            </div>;
          })()}
          {event.description&&<div style={{fontSize:16,color:"var(--muted)",lineHeight:1.6,marginTop:8,whiteSpace:"pre-wrap"}}>
            {event.description}
          </div>}

          {/* Partecipazione — dentro il box evento */}
          {isMusicianUser&&event.visibility==="open"&&<>
            <div style={{height:1,background:"var(--border)",margin:"14px 0 4px"}}/>
            {isParticipating
              /* Si tocca il proprio stato per cambiarlo: niente scritte
                 "non vengo" sempre in vista, l'uscita sta nella finestra. */
              ?<button onClick={()=>{setShowEditParticipation(true);setConfirmLeaveEvent(true);}}
                  aria-label="Sei dentro: tocca per gestire la tua partecipazione"
                  style={{display:"inline-flex",alignItems:"center",minHeight:44,
                    background:"none",border:"none",padding:0,cursor:"pointer",fontFamily:"inherit",textAlign:"left"}}>
                  {/* Pallino, scritta e freccia sulla stessa riga di testo, allineati
                      al centro della "o" di "dentro": in Exo 2 Bold quel centro sta
                      a 0,2475 em sopra la linea di base (4,70px a 19px). Pallino alto
                      10px: base a 4,70-5 = -0,30px. Freccia alta 18px con la punta a
                      meta': base a 4,70-9 = -4,30px. Il browser arrotonda vertical-align
                      al pixel intero, quindi il resto va con translateY (0,3px il pallino,
                      0,22px la freccia: misurato sui pixel, la punta arrotondata pesa). */}
                  <span style={{fontSize:19,fontWeight:700,color:'var(--text)',lineHeight:1,whiteSpace:'nowrap'}}>
                    <span style={{display:'inline-block',width:10,height:10,borderRadius:'50%',background:'var(--brand)',
                      boxShadow:'0 0 0 3px rgba(237,77,29,0.25)',verticalAlign:'baseline',transform:'translateY(0.3px)',marginRight:12}}/>
                    Sei dentro
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--brand)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
                      style={{display:'inline-block',verticalAlign:'-4px',transform:'translateY(0.22px)',marginLeft:4}}><polyline points="9 18 15 12 9 6"/></svg>
                  </span>
                </button>
              :<button onClick={partecipa} disabled={entrando}
                  style={{width:'100%',background:'#ED4D1D',color:'#fff',border:'none',borderRadius:12,
                    padding:'14px',fontSize:19,fontWeight:800,cursor:'pointer',
                    letterSpacing:'.3px',boxShadow:'0 4px 16px rgba(237,77,29,0.4)'}}>
                  {entrando?<span className="spinner"/>:"CLICCA PER PARTECIPARE"}
                </button>
            }
          </>}
        </div>
      </div>
      );})()}

      {/* Proposta "Metti Jammo sulla Home": a chi ha appena detto Partecipo
          (o organizza), solo da telefono e solo se non e' gia' installata. */}
      {(isParticipating||canManage)&&<SchedaHome/>}

      {/* Organizer actions */}
      {canManage&&<div style={{display:"flex",gap:8,alignItems:"center",marginBottom:12,flexWrap:"wrap"}}>
        {isManager&&<span style={{fontSize:16,padding:"3px 10px",borderRadius:999,background:"rgba(237,77,29,0.08)",border:"1px solid rgba(237,77,29,0.2)",color:"var(--muted)"}}>Organizzi</span>}
        {onEditEvent&&<button style={{fontSize:16,padding:"3px 10px",borderRadius:999,background:"rgba(237,77,29,0.08)",border:"1px solid rgba(237,77,29,0.2)",color:"var(--muted)",cursor:"pointer"}} onClick={()=>setShowEditEvent(true)}>Modifica evento</button>}
      </div>}
      {/* Invite modal */}
      {showAddMusician&&<Modal onClose={()=>{setShowAddMusician(false);setMusicianSearch("");}}>
        <div className="modal-title">Aggiungi musicista</div>
        <input className="form-input" placeholder="Cerca per nome..." autoFocus
          value={musicianSearch} onChange={e=>setMusicianSearch(e.target.value)}
          style={{marginBottom:12}}/>
        <div style={{maxHeight:320,overflowY:"auto",display:"flex",flexDirection:"column",gap:2}}>
          {activeMusicians(musicians)
            .filter(m=>
              m.account_type!=="venue"&&
              !participants.some(p=>p.musician_id===m.id)&&
              (musicianSearch.trim()===""||m.name.toLowerCase().includes(musicianSearch.toLowerCase()))
            )
            .sort((a,b)=>a.name.localeCompare(b.name,"it"))
            .map(m=>(
              <div key={m.id}
                onClick={async()=>{
                  if(addingMusician)return;
                  setAddingMusician(m.id);
                  try{
                    await inviteToEvent(event.id,m.id);
                    await load();
                    setShowAddMusician(false);
                    setMusicianSearch("");
                  }finally{setAddingMusician(null);}
                }}
                style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",borderRadius:10,
                  cursor:addingMusician?"default":"pointer",opacity:addingMusician&&addingMusician!==m.id?0.4:1,
                  background:addingMusician===m.id?"rgba(237,77,29,0.08)":"transparent",
                  transition:"background .1s"}}
                onMouseEnter={e=>{if(!addingMusician)e.currentTarget.style.background="var(--surface2)";}}
                onMouseLeave={e=>{if(!addingMusician)e.currentTarget.style.background="transparent";}}>
                {m.avatar_url
                  ?<img src={m.avatar_url} alt="" style={{width:38,height:38,borderRadius:"50%",objectFit:"cover",flexShrink:0}}/>
                  :<div className="avatar" style={{width:38,height:38,fontSize:16,flexShrink:0}}>{m.name.charAt(0)}</div>
                }
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:17,fontWeight:700,color:"var(--text)"}}>{m.name}</div>
                  {(m.default_sings||m.default_instrument)&&(
                    <div style={{fontSize:16,color:"var(--muted)"}}>
                      {[m.default_sings&&"Voce",m.default_instrument].filter(Boolean).join(" · ")}
                    </div>
                  )}
                </div>
                {addingMusician===m.id&&<span className="spinner" style={{flexShrink:0}}/>}
              </div>
            ))
          }
          {activeMusicians(musicians).filter(m=>
            m.account_type!=="venue"&&
            !participants.some(p=>p.musician_id===m.id)&&
            (musicianSearch.trim()===""||m.name.toLowerCase().includes(musicianSearch.toLowerCase()))
          ).length===0&&(
            <div style={{fontSize:16,color:"var(--muted)",padding:"16px 0",textAlign:"center"}}>
              {musicianSearch?"Nessun musicista trovato":"Tutti i musicisti registrati partecipano già"}
            </div>
          )}
        </div>
        <div style={{marginTop:12,textAlign:"center"}}>
          <button className="btn btn-ghost btn-sm" onClick={()=>{setShowAddMusician(false);setMusicianSearch("");}}>Chiudi</button>
        </div>
      </Modal>}

      {showInvite&&<Modal onClose={()=>setShowInvite(false)}>
          <div className="modal-title">Invita musicisti</div>
          <div style={{background:"var(--surface2)",border:"1px solid var(--border)",borderRadius:12,padding:"14px",marginBottom:16,fontSize:16,lineHeight:1.7,whiteSpace:"pre-wrap",wordBreak:"break-word"}}>
            {inviteText()}
          </div>
          <div style={{display:"flex",gap:8}}>
            <button className="btn btn-secondary" style={{flex:1,justifyContent:"center"}} onClick={handleCopy}>
              {copied?"Copiato!":"Copia testo"}
            </button>
            <button className="btn btn-primary" style={{flex:1,justifyContent:"center"}} onClick={handleWhatsApp}>
              Apri WhatsApp
            </button>
          </div>
          <div style={{marginTop:12,textAlign:"center"}}>
            <button className="btn btn-ghost btn-sm" onClick={()=>setShowInvite(false)}>Chiudi</button>
          </div>
      </Modal>}

      {canManage&&pendingRequests.length>0&&<div className="card" style={{marginBottom:14,borderColor:"rgba(237,77,29,0.3)"}}>
        <div style={{fontWeight:700,marginBottom:10,fontSize:16}}>Richieste di adesione ({pendingRequests.length})</div>
        {pendingRequests.map(r=>{const m=musicians.find(mu=>mu.id===r.musician_id);return(
          <div key={r.musician_id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"7px 0",borderBottom:"1px solid var(--border)"}}>
            <span style={{fontSize:16}}>{m?.name||"?"}</span>
            <div style={{display:"flex",gap:6}}>
              <button className="btn btn-xs btn-success" onClick={async()=>{
                await approveEventRequest(event.id,r.musician_id);
                // Auto-aderisce il musicista approvato
                await joinEventAsParticipant(event.id,r.musician_id,[]);
                await load();
              }}>✓ Approva</button>
              <button className="btn btn-xs btn-danger" onClick={async()=>{await rejectEventRequest(event.id,r.musician_id);await load();}}>✕ Rifiuta</button>
            </div>
          </div>
        );})}
      </div>}

      {/* Accesso riservato per eventi privati */}
      {event.visibility==="private"&&!hasAccess&&(
        <div style={{marginBottom:14,padding:"14px 16px",background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:12,textAlign:"center"}}>
          <div style={{fontSize:17,fontWeight:700,color:"var(--text)",marginBottom:4}}>Evento privato</div>
          <div style={{fontSize:16,color:"var(--muted)"}}>Puoi accedere solo tramite link di invito.</div>
        </div>
      )}

      {/* Richiesta adesione per eventi su richiesta — visibile anche senza accesso */}
      {isMusicianUser&&event.visibility==="request"&&!isParticipating&&(
        isPending
          ?<div style={{marginBottom:14,padding:"10px 14px",background:"rgba(237,77,29,.06)",border:"1px solid rgba(237,77,29,.25)",borderRadius:12,fontSize:16,color:"var(--magenta)"}}>
              Richiesta inviata — in attesa di approvazione
            </div>
          :myRequest?.status==="rejected"
            ?<div style={{marginBottom:14,padding:"10px 14px",background:"rgba(255,71,87,.08)",border:"1px solid rgba(255,71,87,.3)",borderRadius:12,fontSize:16,color:"var(--danger)"}}>
                La tua richiesta è stata rifiutata.
              </div>
            :!myRequest&&<div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14,padding:"10px 14px",background:"var(--surface2)",border:"1px solid var(--border)",borderRadius:12}}>
                <span style={{fontSize:16,color:"var(--muted)"}}>Jam su richiesta — chiedi di aderire</span>
                <button className="btn btn-primary btn-sm" onClick={async()=>{await requestJoinEvent(event.id,currentUser.id);await load();}}>Richiedi adesione</button>
              </div>
      )}

      {hasAccess&&<>

        {/* ── BRANI ── */}
        <div style={braniExpanded?openCard:cardStyle}>
          <div style={cardRowStyle} onClick={()=>setBraniExpanded(o=>!o)}>
            <div style={{flex:1,minWidth:0}}>
              <div style={sectionTitleStyle}>Brani</div>
              {!loading&&(
                <div style={{fontSize:16,color:"var(--muted)",marginTop:4}}>
                  {normalTracks.length===0
                    ? "Nessun brano ancora"
                    : (()=>{
                        const miei=normalTracks.filter(t=>(t.track_players||[]).some(p=>p.musician_id===currentUser.id)).length;
                        return `${normalTracks.length} brani${miei>0?` · ${miei} tuoi`:""}${!hasAnyVoice&&normalTracks.length>0?" · voce cercasi":""}`;
                      })()
                  }
                </div>
              )}
            </div>
            <Chevron open={braniExpanded}/>
          </div>
          {/* Fuori dalla riga cliccabile: toccarlo non apre e chiude la card. */}
          {/* Si vede sempre, a musicisti e organizzatori. Prima spariva del tutto
              quando le proposte erano chiuse dalla pagina live, e il musicista
              non capiva perche'. */}
          {!loading&&(isMusicianUser||canManage)&&!proposalsOpen&&!canManage&&(
            <div style={{padding:"0 18px 16px"}}>
              <div style={{width:"100%",minHeight:54,display:"flex",alignItems:"center",justifyContent:"center",boxSizing:"border-box",
                background:"rgba(255,255,255,0.05)",color:"var(--muted)",border:"1px solid var(--border)",borderRadius:14,
                fontSize:18,fontWeight:700,padding:"10px 14px",textAlign:"center"}}>
                Proposte chiuse
              </div>
              <div style={{fontSize:16,color:"var(--muted)",lineHeight:1.5,marginTop:8,textAlign:"center"}}>
                Chi organizza ha chiuso le proposte. Puoi ancora aggiungerti ai brani che ci sono.
              </div>
            </div>
          )}
          {!loading&&(isMusicianUser||canManage)&&(proposalsOpen||canManage)&&(
            <div style={{padding:"0 18px 16px"}}>
              <button onClick={()=>setShowAdd(true)}
                style={{width:"100%",minHeight:54,display:"flex",alignItems:"center",justifyContent:"center",gap:10,
                  background:"#ED4D1D",color:"#fff",border:"none",borderRadius:14,cursor:"pointer",
                  fontSize:19,fontWeight:800,fontFamily:"inherit",boxShadow:"0 4px 16px rgba(237,77,29,0.35)"}}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>
                Proponi un brano
              </button>
              {canManage&&!proposalsOpen&&(
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,marginTop:8}}>
                  <span style={{fontSize:16,color:"var(--muted)",lineHeight:1.4}}>Le proposte dei musicisti sono chiuse</span>
                  <button onClick={async()=>{setProposalsOpen(true);try{await updateEventProposalsOpen(event.id,true);}catch(e){console.error(e);setProposalsOpen(false);}}}
                    style={{flexShrink:0,minHeight:44,padding:"6px 14px",borderRadius:999,cursor:"pointer",fontFamily:"inherit",
                      fontSize:16,fontWeight:700,background:"rgba(237,77,29,0.08)",color:"var(--brand)",border:"1px solid rgba(237,77,29,0.3)"}}>
                    Riaprile
                  </button>
                </div>
              )}
            </div>
          )}
          {braniExpanded&&<div style={cardBodyStyle}>
            {loading&&<div style={{padding:"16px 0",textAlign:"center"}}><div className="spinner"/></div>}

            {!loading&&<>
              {isMusicianUser&&<div style={{fontSize:16,color:"var(--muted)",lineHeight:1.55,marginBottom:12}}>
                Scegli in quali brani suonare cliccando il tuo strumento, o proponi un brano.
              </div>}
              {/* Filtro */}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,gap:8}}>
                <div style={{display:"flex",gap:4}}>
                  {[["tutti","Tutti"],["miei","Tuoi"]].map(([val,label])=>(
                    <button key={val} onClick={()=>setTrackFilter(val)}
                      style={{padding:"4px 16px",minHeight:44,borderRadius:999,border:"none",cursor:"pointer",
                        fontSize:16,fontWeight:600,fontFamily:"inherit",
                        background:trackFilter===val?"#ED4D1D":"rgba(237,77,29,0.06)",
                        color:trackFilter===val?"#fff":"var(--muted)"}}>
                      {label}
                    </button>
                  ))}
                </div>
                <button onClick={()=>handleSortDir(sortDir==="asc"?"desc":"asc")}
                  title={sortDir==="asc"?"Ordine: meno coperti prima":"Ordine: più coperti prima"}
                  style={{display:"flex",alignItems:"center",gap:5,padding:"4px 10px",borderRadius:999,
                    border:"none",cursor:"pointer",fontSize:16,fontWeight:600,
                    background:"rgba(237,77,29,0.06)",color:"var(--muted)"}}>
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
                    <line x1="2" y1="3" x2="9" y2="3"/>
                    <line x1="2" y1="7" x2="7" y2="7"/>
                    <line x1="2" y1="11" x2="5" y2="11"/>
                    {sortDir==="asc"
                      ? <polyline points="12,11 12,4 10,6" strokeLinejoin="round"/>
                      : <polyline points="12,4 12,11 10,9" strokeLinejoin="round"/>}
                  </svg>
                  {sortDir==="asc"?"Da coprire":"Più coperti"}
                </button>
              </div>
              <div style={{opacity:isMusicianUser&&!isParticipating&&!canManage?0.35:1,
                pointerEvents:isMusicianUser&&!isParticipating&&!canManage?'none':'auto'}}>
                {filteredNormal.length===0&&<div style={{textAlign:"center",padding:"12px 0",color:"var(--muted)",fontSize:17,lineHeight:1.5}}>
                  {trackFilter==="miei"&&normalTracks.length>0
                    ?"Non suoni ancora in nessun brano. Tocca il tuo strumento su un brano per aggiungerti."
                    :"Nessun brano ancora."}
                </div>}
                {readyTracks.map((t,i)=><SetlistItem key={t.id} track={t} index={i} sectionIndex={0} canManage={canManage}
                  currentUser={currentUser} musicians={musicians} onJoin={handleJoin} onLeave={handleLeave} onRemove={handleRemove}
                  onShowMusician={setPopupMusician} isParticipating={isParticipating} onEdit={setEditTrack}
                  score={null}/>)}
                {draftTracks.length>0&&<>
                  <div className="setlist-section-header">
                    <div className="setlist-section-line"/>
                    <div className="setlist-section-label" style={{color:"var(--muted)"}}>Cercano ancora qualcuno</div>
                    <div className="setlist-section-line"/>
                  </div>
                  {draftTracks.map((t,i)=><SetlistItem key={t.id} track={t} index={readyTracks.length+i} sectionIndex={1} canManage={canManage}
                    currentUser={currentUser} musicians={musicians} onJoin={handleJoin} onLeave={handleLeave} onRemove={handleRemove}
                    onShowMusician={setPopupMusician} isParticipating={isParticipating} onEdit={setEditTrack}
                    score={null}/>)}
                </>}
              </div>
              {/* Brani ancora disponibili, dopo l'elenco: si clicca e restano solo quelli
                  scoperti per quello strumento. Solo per chi organizza. */}
              {!loading&&canManage&&disponibili.length>0&&(
                <div style={{marginTop:16,padding:"14px 14px 12px",borderRadius:12,
                  background:"rgba(255,255,255,0.03)",border:"1px solid var(--card-border)"}}>
                  <div style={{fontSize:16,fontWeight:700,color:"var(--muted)",
                    textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:10}}>
                    Brani ancora disponibili
                  </div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                    {disponibili.map(({strumento,count})=>{
                      const attivo=trackFilter===`libero:${strumento}`;
                      return (
                        <button key={strumento}
                          onClick={()=>setTrackFilter(attivo?"tutti":`libero:${strumento}`)}
                          style={{display:"flex",alignItems:"center",gap:8,minHeight:44,
                            padding:"8px 14px",borderRadius:999,cursor:"pointer",
                            border:attivo?"none":"1px solid rgba(237,77,29,0.25)",
                            background:attivo?"#ED4D1D":"rgba(237,77,29,0.06)",
                            color:attivo?"#fff":"var(--text)",
                            fontSize:17,fontWeight:600}}>
                          {strumento}
                          <span style={{fontSize:17,fontWeight:800,
                            color:attivo?"#fff":"var(--brand)"}}>{count}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
              {(canManage||isParticipating)&&<div style={{display:"flex",flexDirection:"column",gap:8,marginTop:16,paddingTop:14,borderTop:"1px solid var(--border)"}}>
                {canManage&&<button style={{width:"100%",padding:"12px",minHeight:48,borderRadius:12,cursor:"pointer",
                  background:"rgba(237,77,29,0.06)",color:"var(--brand)",fontWeight:700,fontSize:17,fontFamily:"inherit",
                  border:"1px solid rgba(237,77,29,0.3)"}}
                  onClick={()=>setShowScaletta(true)}>
                  Apri scaletta
                </button>}
                {normalTracks.length>0&&(
                  <button className="btn btn-secondary btn-sm" style={{fontSize:16}} onClick={exportCSV}>
                    Esporta scaletta CSV
                  </button>
                )}
              </div>}
            </>}
          </div>}
        </div>


        {/* ── PARTECIPANTI ── (dopo i brani) */}
        {(participants.length>0||canManage)&&(
          <div style={chiVieneExpanded?openCard:cardStyle}>
            <div style={cardRowStyle} onClick={()=>setChiVieneExpanded(o=>!o)}>
              <div style={{flex:1,minWidth:0}}>
                <div style={sectionTitleStyle}>Partecipanti</div>
                {!loading&&(
                  <div style={{fontSize:16,color:"var(--muted)",marginTop:4}}>
                    {participants.length===0?"Ancora nessuno":`${participants.length} partecipant${participants.length===1?"e":"i"}`}
                  </div>
                )}
                {!loading&&hasAccess&&event.visibility!=="private"&&!invitesLocked&&(
                  <div onClick={e=>{e.stopPropagation();setShowInvite(true);}}
                    style={{display:"inline-flex",alignItems:"center",gap:4,marginTop:5,fontSize:16,fontWeight:700,color:"var(--brand)",cursor:"pointer"}}>
                    Invita altri musicisti<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ED4D1D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                  </div>
                )}
                {!loading&&canManage&&event.visibility==="private"&&!invitesLocked&&(
                  <div onClick={e=>{e.stopPropagation();setMusicianSearch("");setShowAddMusician(true);}}
                    style={{display:"inline-flex",alignItems:"center",gap:4,marginTop:5,fontSize:16,fontWeight:700,color:"var(--brand)",cursor:"pointer"}}>
                    Aggiungi musicista<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ED4D1D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                  </div>
                )}
              </div>
              <Chevron open={chiVieneExpanded}/>
            </div>
            {chiVieneExpanded&&<div style={cardBodyStyle}>
              {participants.length===0
                ?<div style={{fontSize:17,color:"var(--muted)",padding:"12px 0"}}>Ancora nessuno. Sii il primo!</div>
                :<div style={{display:"flex",flexDirection:"column"}}>
                  {[...participants]
                    .sort((a,b)=>{
                      const aOrg=isOrgOfEvent(a.musician_id);
                      const bOrg=isOrgOfEvent(b.musician_id);
                      if(aOrg!==bOrg)return aOrg?-1:1;
                      const aName=(musicians.find(mu=>mu.id===a.musician_id)?.name||"").toLowerCase();
                      const bName=(musicians.find(mu=>mu.id===b.musician_id)?.name||"").toLowerCase();
                      return aName.localeCompare(bName,"it");
                    })
                    .map((p,i,arr)=>{
                    const m=musicians.find(mu=>mu.id===p.musician_id);
                    if(!m)return null;
                    const isOrg=event.manager_id===p.musician_id;
                    const isCoOrg=coOrgIds.includes(p.musician_id);
                    const defaultSings=m.default_sings||m.sings||false;
                    const defaultInstr=m.default_instrument||(m.instruments&&m.instruments[0])||null;
                    const brani=tracks.filter(t=>t.type!=="free"&&(t.track_players||[]).some(tp=>tp.musician_id===p.musician_id)).length;
                    const isLast=i===arr.length-1;
                    return(
                      <div key={p.musician_id}
                        onClick={()=>setPopupMusician(m)}
                        style={{display:"flex",alignItems:"center",gap:10,
                          borderBottom:isLast?"none":"1px solid var(--border)",
                          padding:"11px 0",cursor:"pointer"}}>
                        {m.avatar_url
                          ?<img src={m.avatar_url} alt="" style={{width:44,height:44,borderRadius:"50%",objectFit:"cover",flexShrink:0}}/>
                          :<div className="avatar" style={{width:44,height:44,fontSize:18,flexShrink:0}}>{m.name.charAt(0)}</div>
                        }
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                            <span style={{fontSize:17,fontWeight:700,color:"var(--text)"}}>{firstName(m.name)}</span>
                            {isOrg&&<span style={{fontSize:16,color:"var(--muted)"}}>(Organizzatore)</span>}
                            {isCoOrg&&<span style={{fontSize:16,color:"var(--muted)"}}>(Co-organizzatore)</span>}
                          </div>
                          {(defaultSings||defaultInstr)&&(
                            <div style={{display:"flex",gap:5,marginTop:4,flexWrap:"wrap"}}>
                              {defaultSings&&<span style={{fontSize:16,padding:"2px 8px",borderRadius:999,
                                background:"rgba(237,77,29,0.06)",border:"1px solid rgba(237,77,29,0.15)",
                                color:"var(--muted)",whiteSpace:"nowrap"}}>Voce</span>}
                              {defaultInstr&&<span style={{fontSize:16,padding:"2px 8px",borderRadius:999,
                                background:"rgba(237,77,29,0.06)",border:"1px solid rgba(237,77,29,0.15)",
                                color:"var(--muted)",whiteSpace:"nowrap"}}>{defaultInstr}</span>}
                            </div>
                          )}
                        </div>
                        {brani>0&&(
                          <div style={{display:"flex",flexDirection:"column",alignItems:"center",flexShrink:0,minWidth:36}}>
                            <span style={{fontSize:22,fontWeight:800,color:"var(--text)",lineHeight:1}}>{brani}</span>
                            <span style={{fontSize:16,color:"var(--muted)",marginTop:1}}>{brani===1?"brano":"brani"}</span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              }
              {canManage&&<div style={{marginTop:12,paddingTop:12,borderTop:"1px solid var(--border)"}}>
                <button onClick={handleToggleInvitesLock}
                  style={{fontSize:16,padding:"5px 14px",borderRadius:999,border:`1px solid ${invitesLocked?"rgba(255,82,82,0.3)":"rgba(237,77,29,0.25)"}`,
                    background:invitesLocked?"rgba(255,82,82,0.06)":"rgba(237,77,29,0.06)",
                    color:invitesLocked?"#FF5252":"var(--brand)",cursor:"pointer",fontWeight:600}}>
                  {invitesLocked?"Riapri inviti":"Blocca nuovi inviti"}
                </button>
              </div>}
            </div>}
          </div>
        )}

        {/* ── CHAT E AVVISI ── */}
        {isMusicianUser&&(()=>{
          const unreadLabel=unreadChat===1?"1 nuovo messaggio":`${unreadChat} nuovi messaggi`;
          const manager=musicians.find(m=>m.id===event.manager_id);
          const avvisiLabel=avvisiCount===0?"Nessun avviso":`${avvisiCount} avvis${avvisiCount===1?"o":"i"}`;
          return(
          <div style={showChatOverlay?openCard:cardStyle}>
            <div style={cardRowStyle} onClick={()=>{
              const opening=!showChatOverlay;
              setShowChatOverlay(o=>!o);
              if(opening){
                setUnreadChat(0);
                localStorage.setItem(`jamup_bacheca_seen_${event.id}_${currentUser.id}`,new Date().toISOString());
              }
            }}>
              <div style={{flex:1,minWidth:0,overflow:"hidden"}}>
                <div style={sectionTitleStyle}>Chat e avvisi</div>
                <div style={{fontSize:16,color:"var(--muted)",marginTop:4}}>
                  {avvisiLabel}{unreadChat>0?` · ${unreadLabel}`:""}
                </div>
                {whatsappGroupLink&&(
                  <div onClick={e=>{e.stopPropagation();window.open(whatsappGroupLink,'_blank');}}
                    style={{display:"inline-flex",alignItems:"center",gap:4,marginTop:5,fontSize:16,fontWeight:700,color:"var(--brand)",cursor:"pointer"}}>
                    Vai alla chat dell'evento<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ED4D1D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                  </div>
                )}
              </div>
              <div style={{display:"flex",alignItems:"center",gap:6,flexShrink:0}}>
                <Chevron open={showChatOverlay}/>
              </div>
            </div>
            {showChatOverlay&&<div style={cardBodyStyle}>
              <div style={{paddingTop:14}}>
                <ChatSection eventId={event.id} currentUser={currentUser} musicians={musicians}
                  onShowMusician={setPopupMusician}
                  onNewMessage={()=>{}}
                  whatsappLink={whatsappGroupLink}
                  canManage={canManage}
                  manager={manager}
                  onSaveWhatsappLink={async(link)=>{
                    await updateEventWhatsappLink(event.id,link);
                    setWhatsappGroupLink(link||null);
                  }}/>
              </div>
            </div>}
          </div>
          );
        })()}

        {/* ── IDEE PER LA SERATA ── */}
        {!mostraIdee&&canManage&&renderCardSpenta("Idee per la serata","ideas")}
        {mostraIdee&&<div style={ideasExpanded?openCard:cardStyle}>
          <div style={cardRowStyle} onClick={()=>setIdeasExpanded(o=>!o)}>
            <div style={{flex:1,minWidth:0}}>
              <div style={sectionTitleStyle}>Idee per la serata</div>
              {!loading&&(
                <div style={{fontSize:16,color:"var(--muted)",marginTop:4}}>
                  {ideas.length===0?"Nessuna proposta ancora":`${ideas.length} propost${ideas.length===1?"a":"e"}`}
                </div>
              )}
              {!loading&&(isParticipating||canManage)&&(
                <div onClick={e=>{e.stopPropagation();setShowAddIdea(true);setNewIdeaText("");}}
                  style={{display:"inline-flex",alignItems:"center",gap:4,marginTop:5,fontSize:16,fontWeight:700,color:"var(--brand)",cursor:"pointer"}}>
                  Proponi qualcosa<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ED4D1D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
              )}
            </div>
            <Chevron open={ideasExpanded}/>
          </div>
          {ideasExpanded&&<div style={cardBodyStyle}>
            <div style={{paddingTop:14}}>
              <IdeasSection
                ideas={ideas}
                musicians={musicians}
                currentUser={currentUser}
                canManage={canManage}
                onRefresh={load}/>
              {canManage&&renderNascondiCard("ideas")}
            </div>
          </div>}
        </div>}

        {showAddIdea&&<Modal onClose={()=>setShowAddIdea(false)}>
          <div className="modal-title">Proponi un'idea</div>
          <div style={{fontSize:16,color:"var(--muted)",marginBottom:14,lineHeight:1.55}}>
            Generi, artisti, gruppi — lancialo qui, gli altri possono votare.
          </div>
          <input autoFocus value={newIdeaText} onChange={e=>setNewIdeaText(e.target.value)}
            onKeyDown={async e=>{if(e.key==='Enter'&&newIdeaText.trim()&&!addIdeaLoading){setAddIdeaLoading(true);await addEventIdea(event.id,currentUser.id,newIdeaText.trim());await load();setShowAddIdea(false);setAddIdeaLoading(false);}}}
            placeholder="Es. Blues lento, Rolling Stones…"
            style={{width:"100%",boxSizing:"border-box",background:"var(--surface)",border:"1px solid var(--border)",
              borderRadius:10,padding:"11px 13px",fontSize:18,color:"var(--text)",outline:"none",marginBottom:16}}/>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={()=>setShowAddIdea(false)}>Annulla</button>
            <button className="btn btn-primary" disabled={!newIdeaText.trim()||addIdeaLoading}
              onClick={async()=>{setAddIdeaLoading(true);await addEventIdea(event.id,currentUser.id,newIdeaText.trim());await load();setShowAddIdea(false);setAddIdeaLoading(false);}}>
              {addIdeaLoading?<span className="spinner"/>:"Proponi"}
            </button>
          </div>
        </Modal>}

        {/* ── STRUMENTI E ATTREZZATURA ── */}
        {!mostraAttrezzatura&&canManage&&renderCardSpenta("Strumenti e attrezzatura","equipment")}
        {mostraAttrezzatura&&<div style={attrezzaturaExpanded?openCard:cardStyle}>
          <div style={cardRowStyle} onClick={()=>setAttrezzaturaExpanded(o=>!o)}>
            <div style={{flex:1,minWidth:0}}>
              <div style={sectionTitleStyle}>Strumenti e attrezzatura</div>
              {!loading&&(
                <div style={{fontSize:16,color:"var(--muted)",marginTop:4}}>
                  {missingSlots.length===0
                    ?"Tutto coperto"
                    :`Manca: ${missingSlots.map(s=>s.label).join(", ")}`}
                </div>
              )}
              {!loading&&isMusicianUser&&(
                <div onClick={e=>{e.stopPropagation();setAttrezzaturaExpanded(true);}}
                  style={{display:"inline-flex",alignItems:"center",gap:4,marginTop:5,fontSize:16,fontWeight:700,color:"var(--brand)",cursor:"pointer"}}>
                  Cosa porti<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#ED4D1D" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
              )}
            </div>
            <Chevron open={attrezzaturaExpanded}/>
          </div>
          {attrezzaturaExpanded&&<div style={cardBodyStyle}>
            <div style={{paddingTop:14}}>
              {missingSlots.length>0&&(
                <div style={{marginBottom:14}}>
                  <div style={{fontSize:16,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".8px",marginBottom:8}}>Cercasi</div>
                  <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                    {missingSlots.map(s=>(
                      <span key={s.label} style={{fontSize:16,padding:"4px 12px",borderRadius:999,background:"rgba(255,82,82,0.08)",border:"1px solid rgba(255,82,82,0.3)",color:"#FF5252"}}>
                        {s.label}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              <EquipmentSection eventId={event.id} equipment={equipment} musicianEquipment={musicianEquipment}
                musicians={musicians} currentUser={currentUser} canManage={canManage} onRefresh={load}
                venue={venue}
                venueEquipmentList={venueEquipment[event.venue_id]||[]}
              />
              {canManage&&renderNascondiCard("equipment")}
            </div>
          </div>}
        </div>}

        {/* ── LIVE ── pulsanti sempre visibili, nessun doppio livello */}
        {!mostraLive&&canManage&&renderCardSpenta("Live","live")}
        {mostraLive&&(canManage||isParticipating)&&(()=>{
          const liveBg=venue?.background_image_url||defaultVenueBg;
          return(
          <div style={{position:'relative',marginBottom:24,borderRadius:16,overflow:'hidden',border:"1px solid rgba(237,77,29,0.35)"}}>
            {liveBg
              ?<><img src={liveBg} alt="" style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',display:'block'}}/><div style={{position:'absolute',inset:0,background:'rgba(18,14,10,0.72)'}}/></>
              :event.image_url
                ?<img src={event.image_url} alt="" style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',filter:'blur(14px)',transform:'scale(1.1)',display:'block'}}/>
                :null
            }
            {(liveBg||event.image_url)&&<div style={{position:'absolute',inset:0,background:'rgba(237,77,29,0.18)'}}/>}
            <div style={{position:'relative',padding:"18px 18px"}}>
              <div style={{...sectionTitleStyle,marginBottom:12,color:'#fff'}}>Live</div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>onOpenLive&&onOpenLive(event.id)}
                  style={{flex:1,padding:"13px",borderRadius:12,border:"none",cursor:"pointer",
                    background:"#ED4D1D",color:"#fff",fontWeight:800,fontSize:17,
                    boxShadow:"0 2px 16px rgba(237,77,29,0.5)"}}>
                  Apri pagina live
                </button>
                <button onClick={()=>setShowQR(true)}
                  style={{padding:"13px 16px",borderRadius:12,cursor:"pointer",
                    background:"rgba(255,255,255,0.12)",color:"#fff",fontWeight:800,fontSize:17,
                    border:"1px solid rgba(255,255,255,0.25)"}}>
                  QR
                </button>
              </div>
              {canManage&&(
                <div style={{textAlign:"center",marginTop:10}}>
                  <button onClick={()=>cambiaVisibilitaCard("live",false)}
                    style={{minHeight:44,padding:"8px 12px",background:"none",border:"none",cursor:"pointer",fontFamily:"inherit",
                      fontSize:16,fontWeight:600,color:"rgba(255,255,255,0.75)",textDecoration:"underline"}}>
                    Nascondi ai musicisti
                  </button>
                </div>
              )}
            </div>
          </div>
          );
        })()}

      </>}

      {popupMusician&&<MusicianPopup musician={popupMusician} tracks={tracks}
        onClose={()=>{setPopupMusician(null);setOrgError("");}}
        azioni={renderAzioniOrganizzatore(popupMusician)}/>}
      {showPoster&&event.image_url&&(
        <PosterViewer url={event.image_url} titolo={event.title}
          onClose={()=>setShowPoster(false)}/>
      )}
      {popupVenue&&<VenuePopup venue={popupVenue} equipment={venueEquipment[popupVenue.id]||[]} onClose={()=>setPopupVenue(null)}/>}

      {showScaletta&&<ScalettaView
        event={event} tracks={normalTracks} musicians={musicians}
        canManage={canManage} orderingLocked={orderingLocked}
        onToggleLock={handleToggleLock}
        onReorder={async(trackId,newPos)=>{await updateTrackPosition(trackId,newPos);await load();}}
        onToggleScaletta={async(trackId,add)=>{
          if(add) await addTrackToScaletta(trackId,event.id);
          else await removeTrackFromScaletta(trackId);
          await load();
        }}
        onClose={()=>setShowScaletta(false)}/>}
      {showQR&&<Modal onClose={()=>setShowQR(false)}>
        <div className="modal-title">QR Code — Pagina Live</div>
        <div style={{fontSize:16,color:"var(--muted)",marginBottom:16,lineHeight:1.6}}>
          Mostra questo QR al pubblico. Chi lo scansiona vede la scaletta in tempo reale e può mettere i like.
        </div>
        <QRModal url={`${window.location.origin}${window.location.pathname}#/live/${event.id}`} onClose={()=>setShowQR(false)}/>
      </Modal>}

      {showAdd&&<TrackModal musician={currentUser} onClose={()=>setShowAdd(false)} onSave={handleAddTrack}/>}
      {showEditEvent&&<EventModal existing={event} venues={venues} venueEquipment={venueEquipment||{}} onClose={()=>setShowEditEvent(false)}
        onSave={async(data,eq)=>{await onEditEvent(event.id,data,eq);setShowEditEvent(false);refreshParent&&refreshParent();}}
        onDelete={onDeleteEvent?async(id)=>{await onDeleteEvent(id);}:undefined}/>}
      {editTrack&&<TrackModal musician={currentUser} existing={editTrack} onClose={()=>setEditTrack(null)}
        canManage={canManage} musicians={musicians}
        onShowMusician={setPopupMusician}
        onRemovePlayer={async(musicianId)=>{await dbLeaveTrack(editTrack.id,musicianId);await load();setEditTrack(prev=>prev?{...prev,track_players:(prev.track_players||[]).filter(p=>p.musician_id!==musicianId)}:null);}}
        onAddPlayer={async(musicianId,role)=>{await dbJoinTrack(editTrack.id,musicianId,role,'originale');await load();}}
        onDelete={async()=>{await dbRemoveTrack(editTrack.id);setEditTrack(null);await load();}}
        onSave={async({title,artist,key,bpm,role,tonality})=>{
          await dbUpdateTrack(editTrack.id,{title,artist:artist||"",key:key||null,bpm:bpm||null});
          const myEntry=(editTrack.track_players||[]).find(p=>p.musician_id===currentUser.id);
          if(role) await dbJoinTrack(editTrack.id,currentUser.id,role,tonality);
          else if(myEntry) await dbLeaveTrack(editTrack.id,currentUser.id);
          await load();setEditTrack(null);
        }}/>}
      {confirmRemove&&<Modal onClose={()=>setConfirmRemove(null)}>
        <div className="modal-title">Elimina brano</div>
        <div style={{fontSize:16,color:"var(--muted)",marginBottom:20}}>Sei sicuro? Verranno rimossi anche tutti i musicisti candidati.</div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={()=>setConfirmRemove(null)}>Annulla</button>
          <button className="btn btn-danger" onClick={()=>handleRemoveConfirmed(confirmRemove)}>Elimina</button>
        </div>
      </Modal>}
      {/* Elimina evento — primo warning */}

      {/* Elimina evento — secondo warning */}

      {showFreeJoin&&<Modal onClose={()=>{setShowFreeJoin(null);setFreeNote("");setFreeRole("");}}>
        <div className="modal-title">Candidati alla Jam libera</div>
        <div style={{fontSize:16,color:"var(--muted)",marginBottom:16}}>Cosa suoni nella jam libera?</div>
        <div className="form-group">
          <label className="form-label">Strumento / Voce</label>
          <div className="chip-group" style={{marginBottom:4}}>
            <span className={`chip ${freeRole==="Voce"?"selected":""}`} onClick={()=>setFreeRole(freeRole==="Voce"?"":"Voce")}>Voce</span>
            {INSTRUMENTS.map(i=>(
              <span key={i} className={`chip ${freeRole===i?"selected":""}`} onClick={()=>setFreeRole(freeRole===i?"":i)}>{i}</span>
            ))}
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Aggiunge qualcosa? (facoltativo)</label>
          <input className="form-input" placeholder="es. Miles Davis · Blues in Mi · Funky anni '70" value={freeNote} onChange={e=>setFreeNote(e.target.value)}/>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={()=>{setShowFreeJoin(null);setFreeNote("");setFreeRole("");}}>Annulla</button>
          <button className="btn btn-primary" disabled={!freeRole} onClick={async()=>{
            if(!isParticipating)await joinEventAsParticipant(event.id,currentUser.id,[]);
            await dbJoinTrack(showFreeJoin,currentUser.id,freeRole,freeNote||null);
            await load();setShowFreeJoin(null);setFreeNote("");setFreeRole("");
          }}>Confermo</button>
        </div>
      </Modal>}
      {showEditParticipation&&(confirmLeaveEvent
        ?<Modal onClose={()=>{setShowEditParticipation(false);setConfirmLeaveEvent(false);}} maxWidth={420} centered>
            {(()=>{
              const mieiBrani=normalTracks.filter(t=>(t.track_players||[]).some(p=>p.musician_id===currentUser.id)).length;
              const chiudi=()=>{setShowEditParticipation(false);setConfirmLeaveEvent(false);};
              return <>
                <div className="modal-title" style={{marginBottom:10}}>Sei dentro</div>
                <div style={{fontSize:18,color:"var(--text)",lineHeight:1.55,marginBottom:22}}>
                  Partecipi a <strong>{event.title}</strong>.
                  {mieiBrani>0&&<> Suoni in {mieiBrani===1?"un brano":`${mieiBrani} brani`}.</>}
                </div>
                <button onClick={chiudi}
                  style={{width:"100%",minHeight:52,borderRadius:12,border:"none",cursor:"pointer",fontFamily:"inherit",
                    background:"#ED4D1D",color:"#fff",fontSize:18,fontWeight:800}}>
                  Ci sono
                </button>
                <div style={{borderTop:"1px solid var(--border)",marginTop:22,paddingTop:16}}>
                  <div style={{fontSize:16,color:"var(--muted)",lineHeight:1.5,marginBottom:10}}>
                    Se non puoi più venire, esci dalla serata{mieiBrani>0?" e dai brani in cui suoni":""}. Potrai rientrare quando vuoi.
                  </div>
                  <button onClick={async()=>{
                      await leaveEventAsParticipant(event.id,currentUser.id);
                      await load();refreshParent&&refreshParent();
                      chiudi();
                    }}
                    style={{width:"100%",minHeight:48,borderRadius:12,cursor:"pointer",fontFamily:"inherit",
                      background:"none",border:"1px solid rgba(255,82,82,0.35)",color:"#FF5252",fontSize:17,fontWeight:700}}>
                    Esci dalla serata
                  </button>
                </div>
              </>;
            })()}
          </Modal>
        :null
      )}
    </div>
  );
}


export default SetlistView;
